import { Field, ID, InputType, Int } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Product } from '../Product'

export enum ComputeBillingOfMaterialsStrategy {
  EVENLY = 'EVEN',
  GREEDY = 'GREEDY',
  SEEDING = 'SEEDING',
}

@InputType()
export class ComputeBillingOfMaterialsArgs extends ActionArgs {
  @Field(() => ID)
  productId: string

  @Field(() => Int)
  quantityToBuild: number

  @Field(() => String)
  strategy?: ComputeBillingOfMaterialsStrategy
}

export interface IComputeBillingOfMaterials extends IAction<Product, ComputeBillingOfMaterialsArgs> {}
